import * as React from 'react';
const {
	forwardRef,
	useState,
	useEffect,
	useImperativeHandle,
} = React;

import { Root } from './styled';



export type TimerProps = {
	interval: number;
	onTimeIsOver?: () => void;
}

export type TimerRef = {
	initialize: () => void;
}

const Timer = forwardRef<TimerRef, TimerProps>(({ interval, onTimeIsOver }, ref) => {
	const [ticks, setTicks] = useState(interval);

	useEffect(() => {
		const timerID = setInterval(() => {
			const newTick = ticks - 1;

			setTicks(ticks - 1);
			newTick === 0 && typeof onTimeIsOver === 'function' && onTimeIsOver();
		}, 1000);

		ticks <= 0 && clearInterval(timerID);

		return () => clearInterval(timerID);
	});

	useImperativeHandle(ref, () => ({ initialize: () => setTicks(interval) }));

	return (
		<Root>
			{formatTicks(ticks)}
		</Root>
	);
});

const formatTicks = (count: number) => {
	const timeInMins = count / 60;
	const min = Math.trunc(timeInMins);
	const sec = +(((timeInMins - Math.trunc(timeInMins)) * 60).toFixed(2));

	return sec === 0
		? `${min}:00`
		: sec.toString().length === 1
			?	`${min}:0${sec}`
			: `${min}:${sec}`;
}

export default Timer;
